import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_API_URL;
  const [profile, setProfile] = useState({});

  const handleNavigation = (path) => {
    navigate(path);
  };

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(`${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await profileRes.json();
      setProfile(res.users);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-section">
          <h2 className="footer-logo">
            {profile?.profilePic ? (
              <img
                src={`${url}/uploads/profile/${profile.profilePic}`}
                alt="Logo"
                style={{ height: "40px", objectFit: "contain" }}
              />
            ) : (
              profile?.orignal_logoname || "Skate Ecommerce"
            )}
          </h2>
          <p>Skate Ecommerce – Speed Skating Equipment and Classes Platform.</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/foreverspeedskating?igsh=MXd4MWd4aHhlajFvNA==" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li onClick={() => handleNavigation("/")}>Home</li>
            <li onClick={() => handleNavigation("/course")}>Courses</li>
            <li onClick={() => handleNavigation("/about")}>About Us</li>
            <li onClick={() => handleNavigation("/contact")}>Contact</li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            <li onClick={() => handleNavigation("/refund-policy")}>Refund Policy</li>
            <li onClick={() => handleNavigation("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => handleNavigation("/rules-and-regulations")}>Rules & Regulations</li>
            <li onClick={() => handleNavigation("/shipping-and-delivery")}>Shipping Policy</li>
            <li onClick={() => handleNavigation("/enquiry-form")}>Enquiry</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p><strong>Phone:</strong> +91-7977563085</p>
          <p><strong>Email:</strong> fssacademy2020@gmail.com</p>
          <p><strong>Locations:</strong></p>
          <ul>
            <li>Airoli Sector 8A, Near Dmart, Opp. Sia Sneha Restaurant</li>
            <li>Aquanus Int. School, MG Road, Goregaon West</li>
            <li>CJM School, Opp. Pali Church, Naigaon West</li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {currentYear} All rights reserved. Powered by <a href="https://100billiontech.com/">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
